import usingServiceAdvantage from './usingBobaTeaAdvantage';
import frequentlyAskedQuestions from './boba-tea-dessert-frequentlyAskedQuestions';
const SectionContent = {
  topSection: {
    en: {
      title: 'Bubble Tea POS System',
      description: `The best POS for Boba in the market`,
    },
    zh: {
      title: '奶茶店',
      description: 'Chowbus POS是奶茶店的最佳选择',
    },
  },
  everythingNeedInOnePOSSystem: {
    en: {
      title: 'Recommended Products for Boba Tea & Dessert Shops',
    },
    zh: {
      title: '推荐使用的POS产品',
    },
  },
  usingServiceAdvantage: {
    ...usingServiceAdvantage,
  },
  frequentlyAskedQuestions: {
    ...frequentlyAskedQuestions,
  },
};

export default SectionContent;
